export const warehouseListings = [
  {
    id: 'wh001',
    supplierId: 'sup001',
    supplierName: '李美华',
    supplierAvatar: 'https://public.readdy.ai/ai/img_res/cab8cde0fb0d4d48b6bc4b9b7d0eba6d.jpg',
    supplierCity: '上海',
    supplierFlag: '🇨🇳',
    warehouseCity: '上海仓',
    category: 'clothing',
    categoryLabel: '女装',
    name: '真丝印花连衣裙',
    nameEn: 'Silk Print Dress',
    description: '100%真丝面料，手工印花，优雅大方，适合商务及日常穿着，多色可选',
    price: 168,
    originalPrice: 220,
    currency: '¥',
    stock: 45,
    image: 'https://readdy.ai/api/search-image?query=elegant%20silk%20floral%20print%20dress%20hanging%20on%20rack%20clean%20minimal%20white%20studio%20background%20fashion%20product%20photography&width=400&height=480&seq=wh_p1&orientation=portrait',
    badge: '热销',
    rating: 4.8,
    sold: 312,
    wechat: 'limeihua_sh',
    email: 'limeihua@shop.com',
    shippingDays: '1-2天',
  },
  {
    id: 'wh002',
    supplierId: 'sup002',
    supplierName: '张建国',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20chinese%20man%20supplier%20portrait%20smiling%20confident%20business%20casual%20attire%20clean%20white%20background&width=80&height=80&seq=wh_sup2&orientation=squarish',
    supplierCity: '北京',
    supplierFlag: '🇨🇳',
    warehouseCity: '北京仓',
    category: 'pants',
    categoryLabel: '裤装',
    name: '商务修身西裤',
    nameEn: 'Business Slim Trousers',
    description: '高品质羊毛混纺，修身版型，适合商务场合，多色多码',
    price: 128,
    originalPrice: 180,
    currency: '¥',
    stock: 88,
    image: 'https://readdy.ai/api/search-image?query=slim%20fit%20business%20trousers%20pants%20product%20photography%20clean%20white%20background%20minimal%20fashion&width=400&height=480&seq=wh_p2&orientation=portrait',
    badge: '新品',
    rating: 4.6,
    sold: 156,
    wechat: 'zhangjg_bj',
    email: 'zhangjg@fashion.cn',
    shippingDays: '1-2天',
  },
  {
    id: 'wh003',
    supplierId: 'sup003',
    supplierName: 'Amy Wong',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20hong%20kong%20woman%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup3&orientation=squarish',
    supplierCity: '香港',
    supplierFlag: '🇭🇰',
    warehouseCity: '香港仓',
    category: 'infant',
    categoryLabel: '婴儿服',
    name: '有机棉婴儿礼盒套装',
    nameEn: 'Organic Cotton Baby Gift Set',
    description: '100%有机棉，无荧光剂，柔软亲肤，含连体衣×2、帽子×1、袜子×2',
    price: 89,
    originalPrice: 120,
    currency: 'HK$',
    stock: 60,
    image: 'https://readdy.ai/api/search-image?query=organic%20cotton%20baby%20clothes%20gift%20set%20onesie%20hat%20socks%20pastel%20colors%20clean%20white%20background%20product%20photography&width=400&height=480&seq=wh_p3&orientation=portrait',
    badge: '精选',
    rating: 4.9,
    sold: 428,
    wechat: 'amywong_hk',
    email: 'amy@babylove.hk',
    shippingDays: '2-3天',
  },
  {
    id: 'wh004',
    supplierId: 'sup004',
    supplierName: 'David Tan',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20singapore%20chinese%20man%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup4&orientation=squarish',
    supplierCity: '新加坡',
    supplierFlag: '🇸🇬',
    warehouseCity: '新加坡仓',
    category: 'hat',
    categoryLabel: '帽子',
    name: '经典渔夫帽',
    nameEn: 'Classic Bucket Hat',
    description: '100%棉质，防晒透气，多色可选，男女通用，折叠便携',
    price: 38,
    originalPrice: 55,
    currency: 'S$',
    stock: 200,
    image: 'https://readdy.ai/api/search-image?query=classic%20bucket%20hat%20cotton%20multiple%20colors%20product%20photography%20clean%20white%20background%20minimal%20fashion%20accessories&width=400&height=480&seq=wh_p4&orientation=portrait',
    badge: null,
    rating: 4.5,
    sold: 891,
    wechat: 'davidtan_sg',
    email: 'david@sgfashion.com',
    shippingDays: '2-3天',
  },
  {
    id: 'wh005',
    supplierId: 'sup005',
    supplierName: 'Sarah Liu',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20australian%20chinese%20woman%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup5&orientation=squarish',
    supplierCity: '悉尼',
    supplierFlag: '🇦🇺',
    warehouseCity: '悉尼仓',
    category: 'book',
    categoryLabel: '书籍',
    name: '《幸福婚姻的秘密》精装版',
    nameEn: 'Secrets of Happy Marriage - Hardcover',
    description: '畅销婚恋心理学书籍，作者为知名婚姻咨询师，中英双语版，精装收藏',
    price: 45,
    originalPrice: 68,
    currency: 'A$',
    stock: 120,
    image: 'https://readdy.ai/api/search-image?query=hardcover%20book%20marriage%20happiness%20psychology%20elegant%20cover%20gold%20lettering%20clean%20white%20background%20product%20photography&width=400&height=480&seq=wh_p5&orientation=portrait',
    badge: '畅销',
    rating: 4.7,
    sold: 234,
    wechat: 'sarahliu_syd',
    email: 'sarah@bookstore.au',
    shippingDays: '3-5天',
  },
  {
    id: 'wh006',
    supplierId: 'sup006',
    supplierName: 'Mohammed Al',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20man%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup6&orientation=squarish',
    supplierCity: '迪拜',
    supplierFlag: '🇦🇪',
    warehouseCity: '迪拜仓',
    category: 'stationery',
    categoryLabel: '文具',
    name: '专业彩色铅笔礼盒72色',
    nameEn: 'Professional Color Pencil Set 72pcs',
    description: '油性彩铅，色彩饱满，适合专业绘画及儿童涂色，精美礼盒包装',
    price: 55,
    originalPrice: 80,
    currency: 'AED',
    stock: 75,
    image: 'https://readdy.ai/api/search-image?query=professional%20colored%20pencils%20set%2072%20colors%20gift%20box%20art%20supplies%20clean%20white%20background%20product%20photography&width=400&height=480&seq=wh_p6&orientation=portrait',
    badge: '礼盒装',
    rating: 4.8,
    sold: 167,
    wechat: 'mohammedal_dxb',
    email: 'mo@artstore.ae',
    shippingDays: '3-5天',
  },
  {
    id: 'wh007',
    supplierId: 'sup007',
    supplierName: 'Jenny Chen',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20british%20chinese%20woman%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup7&orientation=squarish',
    supplierCity: '伦敦',
    supplierFlag: '🇬🇧',
    warehouseCity: '伦敦仓',
    category: 'clothing',
    categoryLabel: '女装',
    name: '英伦风格子羊毛大衣',
    nameEn: 'British Plaid Wool Coat',
    description: '经典英伦格纹，70%羊毛，保暖时尚，修身版型，秋冬必备',
    price: 298,
    originalPrice: 420,
    currency: '£',
    stock: 30,
    image: 'https://readdy.ai/api/search-image?query=british%20plaid%20wool%20coat%20elegant%20fashion%20product%20photography%20clean%20white%20studio%20background%20minimal&width=400&height=480&seq=wh_p7&orientation=portrait',
    badge: '限量',
    rating: 4.9,
    sold: 89,
    wechat: 'jennychen_ldn',
    email: 'jenny@ukfashion.co.uk',
    shippingDays: '5-7天',
  },
  {
    id: 'wh008',
    supplierId: 'sup008',
    supplierName: 'Kevin Zhang',
    supplierAvatar: 'https://readdy.ai/api/search-image?query=professional%20american%20chinese%20man%20supplier%20portrait%20smiling%20confident%20business%20attire%20clean%20background&width=80&height=80&seq=wh_sup8&orientation=squarish',
    supplierCity: '纽约',
    supplierFlag: '🇺🇸',
    warehouseCity: '纽约仓',
    category: 'infant',
    categoryLabel: '婴儿服',
    name: '婴儿四季保暖睡袋',
    nameEn: 'Baby All-Season Sleep Sack',
    description: '竹纤维面料，透气调温，适合0-24个月，拉链设计方便换尿布',
    price: 68,
    originalPrice: 95,
    currency: '$',
    stock: 55,
    image: 'https://readdy.ai/api/search-image?query=baby%20sleep%20sack%20bamboo%20fiber%20soft%20pastel%20color%20product%20photography%20clean%20white%20background%20minimal&width=400&height=480&seq=wh_p8&orientation=portrait',
    badge: '爆款',
    rating: 4.7,
    sold: 543,
    wechat: 'kevinzhang_nyc',
    email: 'kevin@babyny.com',
    shippingDays: '5-7天',
  },
];

export const warehouseCities = [
  { city: '上海', flag: '🇨🇳', label: '上海仓', key: 'shanghai' },
  { city: '北京', flag: '🇨🇳', label: '北京仓', key: 'beijing' },
  { city: '香港', flag: '🇭🇰', label: '香港仓', key: 'hongkong' },
  { city: '新加坡', flag: '🇸🇬', label: '新加坡仓', key: 'singapore' },
  { city: '悉尼', flag: '🇦🇺', label: '悉尼仓', key: 'sydney' },
  { city: '迪拜', flag: '🇦🇪', label: '迪拜仓', key: 'dubai' },
  { city: '伦敦', flag: '🇬🇧', label: '伦敦仓', key: 'london' },
  { city: '纽约', flag: '🇺🇸', label: '纽约仓', key: 'newyork' },
];

export const warehouseCategories = [
  { key: 'all', label: '全部', icon: 'ri-apps-line' },
  { key: 'clothing', label: '女装', icon: 'ri-t-shirt-line' },
  { key: 'pants', label: '裤装', icon: 'ri-layout-bottom-line' },
  { key: 'infant', label: '婴儿服', icon: 'ri-heart-line' },
  { key: 'hat', label: '帽子', icon: 'ri-user-smile-line' },
  { key: 'book', label: '书籍', icon: 'ri-book-open-line' },
  { key: 'stationery', label: '文具', icon: 'ri-pencil-line' },
];
